var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19971 15.7915V38.9843H15.7528V29.7739L21.9193 38.9843H29.8407L21.6587 26.8158H15.7528V15.7915H9.19971Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9407 6.1333L31.9254 27.7205L29.9901 24.0703C29.9901 24.0703 28.7002 21.7315 27.6382 20.6714L19.2077 30.3712L14.2686 26.0785L22.7 16.3777C21.5035 15.4717 19.0078 14.5218 19.0078 14.5218L15.1241 13.1142L35.9407 6.1333Z",
    fill: "#E3007E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/키움증권-46.234743c1193d2a738ce4a5068ed38341.svg";
export { ForwardRef as ReactComponent };